import React from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import { Pagination } from "swiper/modules";

const DetailComment = ({ comment }) => {
  const recommendStatus = {
    0: {
      color: "#FF4C4C",
      text: "پیشنهاد نمیکنم",
      image: "/public/assets/dislik.svg",
    },
    1: {
      color: "#33AA57",
      text: "پیشنهاد میکنم",
      image: "/public/assets/finger.svg",
    },
    2: {
      color: "#F7A600!importent",
      text: "مطمعن نیستم",
      image: "/public/assets/alamat.svg",
    },
  };
  return (
    <div className='DetailComment'>
      <div>
        <Swiper
          spaceBetween={10}
          pagination={{
            clickable: true,
          }}
          slidesPerView={1}
          modules={[Pagination]}
          className='mySwiper'
          shortSwipes='2'>
          {comment.images.map((i) => (
            <SwiperSlide className='SlideComment'>
              <img src={i} alt='pic' />
            </SwiperSlide>
          ))}
        </Swiper>
      </div>
      <div>
        <span className='Title'>عنوان نظر اینجا نوشته شود</span>
        <div className='recommended'>
          <img src={recommendStatus[comment.is_recommended].image} alt='pic' />
          <span className='isRecommend'>
            {recommendStatus[comment.is_recommended].text}
          </span>
          <span className='Symbol'>&#8226;</span>
          <span className='Tex'>{comment.name}</span>
          <span className='Symbol'>&#8226;</span>
          <span className='Tex'>خریدار</span>
        </div>
        <div className='Date'>
          <span className='time'>{comment.time}</span>
          <span className='rate'>{comment.rate}</span>
        </div>
        <p>{comment.details.text}</p>
        <div className='commentAdvantages'>
          {comment.details.advantages.map((advantage) => (
            <div>
              <span className='SymbolPlus'>&#43;</span>
              <span className='Text'>{advantage}</span>
            </div>
          ))}
          {comment.details.disadvantages.map((disadvantage) => (
            <div>
              <span className='SymbolMinus'>&#8722;</span>
              <span className='Text'>{disadvantage}</span>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default DetailComment;
